import {
  COGNITO_CLIENT_ID,
  COGNITO_DOMAIN,
  COGNITO_REDIRECT_URL,
  COGNITO_USERPOOL_ID,
} from "../../settings";
import { Amplify } from "aws-amplify";

export function useAwsConfig() {
  if (
    !COGNITO_USERPOOL_ID ||
    !COGNITO_CLIENT_ID ||
    !COGNITO_DOMAIN ||
    !COGNITO_REDIRECT_URL
  ) {
    // TODO: sentryへエラー通知する
    return null;
  }

  const awsConfig: Parameters<typeof Amplify.configure>[0] = {
    Auth: {
      Cognito: {
        userPoolId: COGNITO_USERPOOL_ID,
        userPoolClientId: COGNITO_CLIENT_ID,
        loginWith: {
          oauth: {
            domain: COGNITO_DOMAIN,
            scopes: [
              "email",
              "openid",
              "profile",
              "aws.cognito.signin.user.admin",
            ],
            redirectSignIn: [COGNITO_REDIRECT_URL],
            redirectSignOut: [COGNITO_REDIRECT_URL],
            responseType: "code",
          },
        },
      },
    },
  };

  return awsConfig;
}
